<template>

    <div style="position:relative; width: 100%; height: 100%" v-bind:class="{'open':openSuggestion}" class="typeahead-parts" v-click-outside="closeTypeAhead">
        <input class="search__input" type="text" placeholder="Search Typeahead" v-model="searchkeyword" 
            @keypress.enter.prevent="keywordSearch" @focus="focus" @keyup.down="down"  @keyup.up="up" @input='change'/>

        <ul class="dropdown-menu" style="width:100%" v-bind:class="{'open':openSuggestion}">
            <!-- v-bind:class="{'active': isActive(index)}" -->
            <li v-for="(suggestion,index) in api_results" :key="index" 
            
            @click="suggestionClick(suggestion)">
                <a href="#" class="notranslate">{{ suggestion }}</a>
            </li>
        </ul>
    </div>

    <button class="search__button search__button--end" type="button" @click="keywordSearch">
        <span class="search__button-icon">
        <svg width="20" height="20">
            <path d="M19.2,17.8c0,0-0.2,0.5-0.5,0.8c-0.4,0.4-0.9,0.6-0.9,0.6s-0.9,0.7-2.8-1.6c-1.1-1.4-2.2-2.8-3.1-3.9C10.9,14.5,9.5,15,8,15 	c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7c0,1.5-0.5,2.9-1.3,4c1.1,0.8,2.5,2,4,3.1C20,16.8,19.2,17.8,19.2,17.8z M8,3C5.2,3,3,5.2,3,8 	c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5C13,5.2,10.8,3,8,3z"
            ></path>
        </svg>
        </span>
    </button>
    
</template>


<script>
import axiosvl from "../../../axios/axios-vl.js";

export default {
    data() {
        return {
            open: false,
            current: 0,
            selected: null,
            searchkeyword: '',
            api_results: [],
        }
    },

    computed: {

        //The flag
        openSuggestion() {
            return this.selection !== "" &&
                this.api_results.length != 0 &&
                this.open === true;
        }
    },
    watch: {
        // searchkeyword() {
        //     this.api();
        // }
    },
    methods: {

        api() {
            axiosvl.post(this.$store.getters['api/search_typeahead_uri'], 
				{
					"webroutine": {
						"context": {
							"session-key-method": "hidden"
						},
						"fields": {
							"EHCUST": {
								"value": this.$store.getters.customer
								// "value": "DMS"
							},
                            "TYPEAHEAD" : {
                                "value": this.searchkeyword
                            }
						}
					}
				}
			).then((response) => { 
                const fields = response.data.webroutine.fields;
                const res_withspaces = [];
                this.api_results = [];
				for (const key in response.data.webroutine.lists.PDESCS.entries) { 
					const obj = response.data.webroutine.lists.PDESCS.entries[key];
                    // console.log(obj);
                    // this.api_results.push(obj.TADESCR);
                    if(obj.TADESCR.indexOf(' ') >= 0) {
                        res_withspaces.push(obj.TADESCR);	
                    }else{
                        this.api_results.push(obj.TADESCR);
                    }

                    // res_withspaces.forEach(res => {
                    //     this.api_results.push(res);
                    //     const result = arr1.concat(arr2);
                    // })
                    
				}

                this.api_results = this.api_results.concat(res_withspaces);

                if (fields.NREC.value > 0){
                    this.open = true;
                }

			}).catch(function (error) { 
				console.error("error - " + error);
			});
        },

        //When up pressed while suggestions are open
        up() {
            if(this.current > 0)
                this.current--;
        },

        //When up pressed while suggestions are open
        down() {
            if(this.current < this.api_results.length - 1)
                this.current++;
        },

        //For highlighting element
        isActive(index) {
            return index === this.current;
        },

        //When the user changes input
        change() {
            // this.$emit('typeahead_change', this.searchkeyword);
            this.$store.dispatch('setTypahead_str', this.searchkeyword);
            this.api();
            if (this.open == false) {
                this.open = true;
                this.current = 0;
            }
        },

        //When one of the suggestion is clicked
        suggestionClick(select) {
            this.searchkeyword = '';
            this.selected = select;
            this.open = false;
            // this.selected = this.selected.replaceAll('"', '');
            // this.selected = this.selected.replaceAll('/', ' ');
            this.$emit("selectedSearch", this.selected);
        },

        //When enter pressed on the input
        keywordSearch() {
            // this.selected = this.api_results[this.current];
            this.selected = this.searchkeyword;
            this.open = false;

            if(this.selected == undefined){
                // this.searchkeyword = this.searchkeyword.replaceAll('"', '');
                // this.searchkeyword = this.searchkeyword.replaceAll('/', ' ');
                this.$emit("selectedSearch", this.searchkeyword);
            }else{
                // this.selected = this.selected.replaceAll('"', '');
                // this.selected = this.selected.replaceAll('/', ' ');
                this.$emit("selectedSearch", this.selected);
            }
        },

        closeTypeAhead() {
            if (event.target.closest('.typeahead-parts') != undefined) {
                if (!event.target.closest('.typeahead-parts').className.match(/\btypeahead-parts\b/)) {
                    // Check if this is a child element of the search button
                    if (!event.target.className.match(/\btypeahead-parts\b/)) { 
                    // Check if this is not the actual search button
                    this.open = false;
                    }
                }
            } else {
                this.open = false;
            }
        },

        focus(){
            if(this.searchkeyword != ''){
                this.open = true;
            }
        }
        
    }
}
</script>

<style scoped>
    .search__button.search__button--end {
        margin-right : 15px;
    }
    
    input {
        width: 100%;
        height: 100%;
    }

    .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1000;
        display: none;
        float: left;
        min-width: 160px;
        padding: 5px 0;
        margin: 2px 0 0;
        font-size: 14px;
        text-align: left;
        list-style: none;
        background-color: #fff;
        -webkit-background-clip: padding-box;
                background-clip: padding-box;
        border: 1px solid #ccc;
        border: 1px solid rgba(0, 0, 0, .15);
        border-radius: 4px;
        -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
                box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
    }
    .dropdown-menu.pull-right {
    right: 0;
    left: auto;
    }
    .dropdown-menu .divider {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #e5e5e5;
    }
    .dropdown-menu > li > a {
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: normal;
    line-height: 1.42857143;
    color: #333;
    white-space: nowrap;
    }
    .dropdown-menu > li > a:hover,
    .dropdown-menu > li > a:focus {
    color: #262626;
    text-decoration: none;
    background-color: #f5f5f5;
    }

    .dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {
        color: #fff;
        text-decoration: none;
        background-color: #337ab7;
    }

    .dropdown-menu > .active > a,
    .dropdown-menu > .active > a:hover,
    .dropdown-menu > .active > a:focus {
    color: #fff;
    text-decoration: none;
    background-color: #337ab7;
    outline: 0;
    }
    .dropdown-menu > .disabled > a,
    .dropdown-menu > .disabled > a:hover,
    .dropdown-menu > .disabled > a:focus {
    color: #777;
    }
    .dropdown-menu > .disabled > a:hover,
    .dropdown-menu > .disabled > a:focus {
    text-decoration: none;
    cursor: not-allowed;
    background-color: transparent;
    background-image: none;
    filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);
    }
    .open > .dropdown-menu {
    display: block;
    }
    .open > a {
    outline: 0;
    }
    .dropdown-menu-right {
    right: 0;
    left: auto;
    }
    .dropdown-menu-left {
    right: auto;
    left: 0;
    }
    .dropdown-header {
    display: block;
    padding: 3px 20px;
    font-size: 12px;
    line-height: 1.42857143;
    color: #777;
    white-space: nowrap;
    }
    .dropdown-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 990;
    }
    .pull-right > .dropdown-menu {
    right: 0;
    left: auto;
    }
    .dropup .caret,
    .navbar-fixed-bottom .dropdown .caret {
    content: "";
    border-top: 0;
    border-bottom: 4px dashed;
    border-bottom: 4px solid \9;
    }
    .dropup .dropdown-menu,
    .navbar-fixed-bottom .dropdown .dropdown-menu {
    top: auto;
    bottom: 100%;
    margin-bottom: 2px;
    }
    @media (min-width: 768px) {
    .navbar-right .dropdown-menu {
        right: 0;
        left: auto;
    }
    .navbar-right .dropdown-menu-left {
        right: auto;
        left: 0;
    }
    }
</style>